import Layout from "../views/layout/Layout";
import config from '../Config'

export default {
    path: '/operation',
    component: Layout,
    redirect: '/operation/order',
    meta: { title: '运营管理', icon: 'el-icon-s-operation' },
    children: [{
        path: 'order',
        name: 'order',
        component: () => import('@/views/operation/order/index'),
        meta: { title: '宝订单管理', icon: 'product-cate' },
        auth: 'operation:order'
    }, {
        path: 'line-order',
        name: 'line-order',
        component: () => import('@/views/operation/lineOrder/line-order'),
        meta: { title: '线订单管理', icon: 'product-cate' },
        auth: 'operation:order'
    }, {
        path: 'buyOrder',
        name: 'buyOrder',
        component: () => import('@/views/operation/buyOrder/index'),
        meta: { title: '已购买订单管理', icon: 'product-cate' },
        auth: 'operation:order'
    }, {
        path: 'recharge',
        name: 'recharge',
        component: () => import('@/views/operation/recharge/index'),
        meta: { title: '充值管理', icon: 'product-cate' },
        auth: 'operation:recharge'
    }, {
        path: 'agentBuyOrder',
        name: 'agentBuyOrder',
        component: () => import('@/views/operation/agentBuyOrder/index'),
        meta: { title: '代理购买订单', icon: 'product-cate' },
        auth: 'operation:agentBuyOrder'
    }, {
        path: 'base',
        name: 'base',
        component: () => import('@/views/operation/base/index'),
        meta: { title: '底座管理', icon: 'product-cate' },
        auth: 'operation:base'
    }, {
        path: 'charger',
        name: 'charger',
        component: () => import('@/views/operation/charger/index'),
        meta: { title: '充电线管理', icon: 'product-cate' },
        auth: 'operation:charger'
    }, {
        path: 'reset',
        name: 'reset',
        component: () => import('@/views/operation/reset/index'),
        meta: { title: '设备重置', icon: 'product-cate' },
        auth: 'operation:reset'
    }, {
        path: 'deviceRecord',
        name: 'deviceRecord',
        component: () => import('@/views/operation/deviceRecord/index'),
        meta: { title: '设备操作管理', icon: 'product-cate' },
        auth: 'operation:deviceRecord'
    }, {
        path: 'doc-list',
        name: 'doc-list',
        component: () => import('@/views/operation/docList/index'),
        meta: { title: '网点管理', icon: 'product-cate' },
        auth: 'operation:doc-list'
    }, {
        path: 'dotDetails',
        name: 'dotDetails',
        hidden: true,
        component: () => import('@/views/operation/docList/dotDetails'),
        meta: { title: '网点详情', icon: 'product-cate' },
        auth: 'operation:dotDetails'
    }, {
        path: 'area',
        name: 'area',
        hidden: true,
        component: () => import('@/views/operation/area/index'),
        meta: { title: '区域代理', icon: 'product-cate' },
        auth: 'operation:area'
    }, {
        path: 'area-plan/:areaId',
        name: 'area-plan',
        hidden: true,
        component: () => import('@/views/operation/area/area-plan'),
        meta: { title: '区域计划', icon: 'product-cate' },
        auth: 'operation:area-plan'
    }, {
        path: 'incomeForm/:id',
        name: 'incomeForm',
        hidden: true,
        component: () => import('@/views/operation/area/incomeForm'),
        meta: { title: '收益报表', icon: 'product-cate' },
        auth: 'operation:incomeForm'
    }, {
        path: 'white-list',
        name: 'white-list',
        component: () => import('@/views/operation/whiteList/index'),
        meta: { title: '白名单管理', icon: 'product-cate' },
        auth: 'operation:white-list'
    }, {
        path: 'white-list-record/:id',
        name: 'white-list-record',
        hidden: true,
        component: () => import('@/views/operation/whiteList/whiteListRecord'),
        meta: { title: '租借记录', icon: 'product-cate' },
        auth: 'operation:white-list-record'
    }, {
        path: 'qrTemplate',
        name: 'qrTemplate',
        component: () => import('@/views/operation/qrTemplate/index'),
        meta: { title: '推广管理', icon: 'product-cate' },
        auth: 'operation:qrTemplate'
    }, {
        path: 'question',
        name: 'question',
        component: () => import('@/views/operation/question/index'),
        meta: { title: '问题反馈', icon: 'product-cate' },
        auth: 'operation:question'
    }, {
        path: 'join',
        name: 'join',
        component: () => import('@/views/operation/join/index'),
        meta: { title: '加盟合作', icon: 'product-cate' },
        auth: 'operation:join'
    }, {
        path: 'base-details',
        name: 'base-details',
        hidden: true,
        component: () => import('@/views/operation/base/details'),
        meta: { title: '底座详情', icon: 'product-cate' },
        auth: 'operation:base-details'
    }, {
        path: 'platformAdv',
        name: 'PlatformAdv',
        component: () => import('@/views/operation/platformAdv/index'),
        meta: { title: '平台投放广告', icon: 'product-cate' },
        auth: 'operation:PlatformAdv'
    }, {
        path: 'platformAdvAudit',
        name: 'platformAdvAudit',
        component: () => import('@/views/operation/platformAdvAudit/index'),
        meta: { title: '平台投放广告审核', icon: 'product-cate' },
        auth: 'operation:platformAdvAudit'
    }, {
        path: 'agentAdv',
        name: 'agentAdv',
        component: () => import('@/views/operation/agentAdv/index'),
        meta: { title: '代理商投放广告', icon: 'product-cate' },
        auth: 'operation:agentAdv'
    }, {
        path: 'agentAdvAudit',
        name: 'agentAdvAudit',
        component: () => import('@/views/operation/agentAdvAudit/index'),
        meta: { title: '代理商投放广告审核', icon: 'product-cate' },
        auth: 'operation:agentAdvAudit'
    }, {
        path: 'charger-details',
        name: 'charger-details',
        hidden: true,
        component: () => import('@/views/operation/charger/details'),
        meta: { title: '充电线详情', icon: 'product-cate' },
        auth: 'operation:charger-details'
    }, {
        path: 'testingAbnormal',
        name: 'testingAbnormal',
        component: () => import('@/views/operation/testingAbnormal/index'),
        meta: { title: '检测异常列表', icon: 'product-cate' },
        auth: 'operation:testingAbnormal'
    }, {
        path: 'testUE',
        name: 'testUE',
        hidden: true,
        component: () => import('@/views/testUE'),
        meta: { title: '百度富文本', icon: 'product-cate' },
        auth: 'operation:testUE'
    }, {
        path: 'businessTransfer',
        name: 'businessTransfer',
        component: () => import('@/views/operation/businessTransfer/index'),
        meta: { title: '商家转移记录', icon: 'product-cate' },
        auth: 'operation:businessTransfer'
    }, {
        path: 'abnormalLeaseRecord',
        name: 'abnormalLeaseRecord',
        component: () => import('@/views/operation/abnormalLeaseRecord/index'),
        meta: { title: '异常租借记录', icon: 'product-cate' },
        auth: 'operation:abnormalLeaseRecord'
    }, {
        path: 'testing',
        name: 'testing',
        component: () => import('@/views/operation/testing/index'),
        meta: { title: '宝重码检测表', icon: 'product-cate' },
        auth: 'operation:testing'
    }, {
        path: 'outerChain',
        name: 'outerChain',
        hidden: config.hideOuterChain,
        component: () => import('@/views/operation/outerChain/index'),
        meta: { title: '外链聚合页配置', icon: 'product-cate' },
        auth: 'operation:outerChain'
    }, {
        path: 'leaseGuide',
        name: 'leaseGuide',
        component: () => import('@/views/operation/leaseGuide/index'),
        hidden: config.hideGuide,
        meta: { title: '租借引导页', icon: 'product-cate' },
        auth: 'operation:leaseGuide'
    }, {
        path: 'adManager',
        name: 'adManager',
        component: () => import('@/views/operation/adManager/index'),
        meta: { title: '广告管理', icon: 'product-cate' },
        auth: 'operation:adManager'
    }, {
        path: 'serviceCondition',
        name: 'serviceCondition',
        component: () => import('@/views/operation/serviceCondition/index'),
        meta: { title: '宝使用状况', icon: 'product-cate' },
        auth: 'operation:serviceCondition'
    }, {
        path: 'export',
        name: 'export',
        component: () => import('@/views/operation/export/index'),
        meta: { title: '报表导出' },
        auth: 'operation:export',
        hidden: true
    }]
}



// WEBPACK FOOTER //
// ./src/router/operation.js